$(document).ready(function () {
    refreshCart(true);

    if (window.location.pathname === "/cart") {
        window.location.href = "/?cart=open";
        return;
    }
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
        openCart();
    }
});

// open cart on navigation
$('.header .icon-cart').on('click', function() {
    openCart();
});

function openCart() {
    $('#popup-cart').css('display', 'flex').hide().fadeIn();
    $('body').css('overflow-y', 'hidden');

    if ($('.popup-order').length && $('.popup-order').css('display') == 'flex')
        $('.popup-order').fadeOut();
}

// close cart
$('#popup-cart .cart-close').on('click', function() {
    closeCart();
});

function closeCart() {
    $('#popup-cart').fadeOut();
    $('body').css('overflow-y', 'visible');
}

// preventing scroll
function preventScroll(event) {
    event.preventDefault();
}

// form add to cart
$('.atc-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $('.btn-atc span').css('visibility', 'hidden');
    $('.btn-atc .atc-overlay').css('display', 'flex');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            openCart();

            $('.btn-atc span').css('visibility', 'visible');
            $('.btn-atc .atc-overlay').css('display', 'none');
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', xhr);
        }
    });
});

// accessory add to cart
$('.accessory-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});


// ymal add to cart
$('.ymal-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});

// item remove to cart
$(document).on('click', '.product-remove', function(event) {
    event.preventDefault();

    let removeUrl = $(this).attr('href'); 

    $.ajax({
        type: 'POST',
        url: removeUrl,
        success: function() {
            refreshCart();
        },
        error: function(xhr, status, error) {
            console.error('Error removing item:', error);
        }
    });
});

// update quantity
var qtyTimer;
function updateQty(updateUrl) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: updateUrl,
            success: function() {
                refreshCart();
            },
            error: function(xhr, status, error) {
                refreshCart();

                console.error('Error updating item:', error);
            }
        });
    }, 100);
}
$(document).on('click', '#popup-cart .less_qty, .main-cart .less_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty >= 0) {
        qty--;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;

        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);
        
        if ($('.main-cart').length) {
            $(`.main-cart .qty[data-key="${key}"]`).val(qty);
        }

        updateQty(updateUrl);
    }
});
$(document).on('click', '#popup-cart .add_qty, .main-cart .add_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty < 100) {
        qty++;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;
        
        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);
        $(`.main-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});

// refresh cart
function refreshCart(isPageLoad = false) {
    
    $('#popup-cart .el-overlay').show();
    $('#popup-cart .option').css('right', '-100%');
    $('#popup-cart .discount-wrapper .discount-message').hide();
    $('#popup-cart .discount-form input').val('');

    $.ajax({
        type: 'GET',
        url: '/',
        dataType: 'html',
        success: function(cartHtml) {
            let newCartItems = $(cartHtml).find('.cart-body').html();
            $('#popup-cart .cart-body').html(newCartItems);

            let newCartTotal = $(cartHtml).find('.cart-total-price').html();
            $('#popup-cart .cart-total-price').html(newCartTotal);

            let totalItems = $(cartHtml).find('.cart').data('total');
            let displayItems = totalItems > 9 ? '9+' : totalItems;

            if ($(cartHtml).find('.cart-body').find('.product-cart').length == 0) {
                $('#popup-cart .cart-checkout a').addClass('disabled');
                $('.header .icon-cart .dot').hide();
                
                if (!isPageLoad) {
                    fetch(`${window.location.origin}/checkout?discount=CLEAR`);
                }
            }
            else {
                $('#popup-cart .cart-checkout a').removeClass('disabled');
                
                $('.header .icon-cart .dot').css('display', 'flex');
                $('.header .icon-cart .dot').html(displayItems);
            }
                
            $('#popup-cart .el-overlay').hide();
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
            $('#popup-cart .el-overlay').hide();
        }
    });
}

// close if away
$('#popup-cart .overlay').on('click', function () {
    closeCart();
});


$(document).on('click', '#popup-cart .cart-checkout a', function(e) {
    e.preventDefault();
    
    let note = $(document).find('[name="order-note"]').val();

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            note: note
        }),
    })
    .then(response => {
        if (response.ok) {
            window.location.href = '/checkout';
        }
    })
    .catch(error => {
        console.error('Error updating cart note:', error);
    });
});